module.exports = __webpack_public_path__ + "img/outgoing-call.a72ec057.svg";